import useFetchObjects from "../../api/useFetchObjects";

/**
 * Custom hook for fetching user's purchased magazines
 *
 * @param {Object} options - Additional options for the query
 * @param {boolean} options.refetchOnWindowFocus - Whether to refetch data when window gains focus
 * @param {number} options.refetchInterval - Interval in ms to refetch data
 * @param {number} options.retry - Number of retry attempts for failed requests
 * @param {number} options.retryDelay - Delay between retry attempts in ms
 *
 * @returns {Object} Query result object containing:
 * @returns {Array} data - Array of purchased magazine items with their details
 * @returns {boolean} isLoading - Loading state
 * @returns {boolean} isError - Error state
 * @returns {boolean} isSuccess - Success state
 * @returns {Object} error - Error object if any
 * @returns {Function} refetch - Function to manually refetch data
 * @returns {JSX.Element} SnackbarMessage - Error message component
 */
const useMagazinePurchases = (options = {}) => {
  return useFetchObjects(
    ["magazine-purchases"],
    "payments/purchase_history/?type=MAGAZINE",
    localStorage.getItem("token"),
    {
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
      cacheTime: 30 * 60 * 1000, // Keep data in cache for 30 minutes
      ...options,
    },
  );
};

export default useMagazinePurchases;
